<template>
  <div class="p-8 flex flex-wrap gap-8">
    <div v-if="userStore.user" class="w-full flex flex-col gap-4">
      <h1>{{ 'Hi ' + userStore.user.nickname }}</h1>
      <div class="flex flex-row flex-wrap gap-8">
        <div v-for="category in categories" :key="category" class="flex flex-col gap-4 w-72">
          <VaButton :to="{ name: 'play', query: { category } }">
            {{ t('home.start') }}: {{ t(`categories.${category}`) }}
          </VaButton>
          <div v-if="mostMissed[category]?.length" class="rounded-xl bg-neutral-700/50 px-4 py-3">
            <h4 class="!mt-0 !mb-2 text-neutral-300">{{ t('home.mostMissed') }}</h4>
            <ol class="list-decimal pl-5 flex flex-col gap-1">
              <li v-for="card in mostMissed[category]" :key="card.id">
                <span class="flex flex-row items-center justify-between gap-2">
                  <span class="flex flex-row items-center">
                    <!-- audio-only questions are not shown, the answer (the word) is what matters here -->
                    <template v-if="card.content">
                      <span v-html="card.content" />
                      <span class="px-2">=</span>
                    </template>
                    <span class="font-bold">{{ card.response }}</span>
                  </span>
                  <span class="text-sm text-red-400 whitespace-nowrap" :title="t('home.wrongCount', { count: card.wrong_count })">
                    ✗ {{ card.wrong_count }}
                  </span>
                </span>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import CardService from '@/services/CardService'
import { MissedCard } from '@/models/Card'
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useUserStore } from '@/stores/UserStore'
import { VaButton } from 'vuestic-ui'

// default categories offered on the home page, spelling bee first
const categories = ['spelling_bee', 'multiplication_tables', 'subtraction_20']

const mostMissed = ref<Record<string, MissedCard[]>>({})
const userStore = useUserStore()
const { t } = useI18n()

onMounted(() => {
  if (!userStore.user) return
  // the 10 questions answered wrongly most often, per category - shown for reflection
  categories.forEach((category) => {
    CardService.getMostMissed(category).then((cards) => {
      mostMissed.value[category] = cards
    })
  })
})
</script>
